import {
  Badge,
  Button,
  Card,
  Col,
  Container,
  Dropdown,
  FloatingLabel,
  Form,
  Placeholder,
  Row,
  Tab,
  Tabs,
} from "react-bootstrap";
import { FloatInput, FloatSelect, HeadPage } from "src/componentes";
import TributacaoCadastroCode from "./TributacaoCadastro.Code";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useUrlTabModule } from "src/hook/useUrlTab.Module";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faPen,
  faChevronRight,
  faReceipt,
} from "@fortawesome/free-solid-svg-icons";

const TributacaoCadastroView = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const navigate = useNavigate();
  const code = TributacaoCadastroCode();
  const tab = useUrlTabModule("tab", "tabDados");

  const handleClickAlterar = (id: number, tributacaoId: number) => () => {
    navigate(
      `/fiscal/tributacao/cfop/cadastro?id=${id}&tributacaoid=${tributacaoId}`
    );
  };

  const handleClickImposto =
    (impostoId: number, tipoImposto: number, cfopId: number) =>
    (e: React.MouseEvent) => {
      e.stopPropagation();
      if (tipoImposto === 4) {
        navigate(
          `/fiscal/tributacao/cfop/imposto/ibscbs/cadastro?id=${impostoId}&type=${tipoImposto}&tributacaocfopid=${cfopId}`
        );
      } else {
        navigate(
          `/fiscal/tributacao/cfop/imposto/cadastro?id=${impostoId}&type=${tipoImposto}&tributacaocfopid=${cfopId}`
        );
      }
    };

  const handleAddImposto =
    (tipoImposto: number, cfopId: number) => (e: React.MouseEvent) => {
      e.stopPropagation();
      if (tipoImposto === 4) {
        navigate(
          `/fiscal/tributacao/cfop/imposto/ibscbs/cadastro?type=4&tributacaocfopid=${cfopId}`
        );
      } else {
        navigate(
          `/fiscal/tributacao/cfop/imposto/cadastro?type=${tipoImposto}&tributacaocfopid=${cfopId}`
        );
      }
    };

  const getBadgeBg = (tipo: number) => {
    switch (tipo) {
      case 0:
        return "warning";
      case 1:
        return "info";
      case 2:
        return "success";
      case 3:
        return "primary";
      case 4:
        return "dark";
      default:
        return "secondary";
    }
  };

  const getSigla = (tipo: number, desc: string) => {
    switch (tipo) {
      case 0:
        return "IC";
      case 1:
        return "IPI";
      case 2:
        return "PIS";
      case 3:
        return "COF";
      case 4:
        return "IBS";
      default:
        return desc.substring(0, 3).toUpperCase();
    }
  };

  return (
    <Container>
      <Form noValidate onSubmit={code.form.handleSubmit(code.onSubmit)}>
        <HeadPage headText="Tributacao Cadastro">
          {id && !code.incluir && !code.loading ? (
            <>
              <Dropdown.Item
                onClick={() =>
                  navigate(`/fiscal/tributacao/cfop/cadastro?tributacaoid=${id}`)
                }
              >
                Nova Cfop...
              </Dropdown.Item>
              <Dropdown.Item onClick={code.onExcluir}>
                Excluir
              </Dropdown.Item>
            </>
          ) : undefined}
        </HeadPage>
        {!code.loading ? (
          <Tabs defaultActiveKey={tab.value} onSelect={tab.set}>
            <Tab eventKey="tabDados" title="Dados">
              <>
                <Row>
                  <Col>
                    <Col xs={12}>
                      <FloatInput
                        registerField={code.form.register("nome")}
                        label="Nome"
                        errorsMessage={code.form.formState.errors.nome}
                        inputMask="capitalizar"
                        maxLength={60}
                      />
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Col xs={12}>
                      <FloatInput
                        label="Natureza Operação"
                        errorsMessage={
                          code.form.formState.errors.naturezaOperacao
                        }
                        registerField={code.form.register("naturezaOperacao")}
                        inputMask="capitalizar"
                        maxLength={60}
                      />
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Col xs={12}>
                      <FloatSelect
                        label="Tipo Operação"
                        options={[
                          { label: "Selecione" },
                          { value: "0", label: "Entrada" },
                          { value: "1", label: "Saída" },
                        ]}
                        register={code.form.register("tipoOperacao")}
                        errorsMessage={code.form.formState.errors.tipoOperacao}
                      />
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <Form.Group>
                      <Form.Check type="checkbox" id="padraoEmissaoCupomFiscal">
                        <Form.Check.Input
                          type="checkbox"
                          {...code.form.register("padraoEmissaoCupomFiscal")}
                          title="Tooltip on top"
                        ></Form.Check.Input>
                        <Form.Check.Label>
                          Emissão cupom fiscal?
                        </Form.Check.Label>
                      </Form.Check>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <Form.Group>
                      <Form.Check type="checkbox" id="padraoEmissaoCTe">
                        <Form.Check.Input
                          type="checkbox"
                          {...code.form.register("padraoEmissaoCTe")}
                        ></Form.Check.Input>
                        <Form.Check.Label>
                          Emissão conhecimento de transporte?
                        </Form.Check.Label>
                      </Form.Check>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} className="d-grid mt-3 mb-5">
                    <Button type="submit">Confirmar</Button>
                  </Col>
                </Row>
              </>
            </Tab>
            {!code.incluir && (
              <Tab
                eventKey="tabCfop"
                title={`CFOP (${code.data?.length || 0})`}
              >
                {/* Cabeçalho e Ação Primária da Tab */}
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 mt-2 gap-2">
                  <div>
                    <h6
                      className="mb-0 text-secondary fw-bold text-uppercase"
                      style={{ fontSize: "0.8rem", letterSpacing: "0.05em" }}
                    >
                      Regras Fiscais por CFOP
                    </h6>
                    <small className="text-muted">
                      {code.data?.length || 0}{" "}
                      {code.data?.length === 1
                        ? "operação cadastrada com regras de tributos"
                        : "operações cadastradas com regras de tributos"}
                    </small>
                  </div>
                  <Button
                    variant="primary"
                    size="sm"
                    className="d-flex align-items-center gap-1 shadow-sm px-3 py-2 fw-semibold"
                    onClick={() =>
                      navigate(
                        `/fiscal/tributacao/cfop/cadastro?tributacaoid=${id}`
                      )
                    }
                  >
                    <FontAwesomeIcon icon={faPlus} />
                    <span>Nova CFOP</span>
                  </Button>
                </div>

                {/* Cards de CFOP ou Empty State */}
                {code.data && code.data.length > 0 ? (
                  <div className="d-flex flex-column gap-3 mb-4">
                    {[...code.data]
                      .sort((a, b) => {
                        const firstDigitA = parseInt(a.cfop[0] || "0");
                        const firstDigitB = parseInt(b.cfop[0] || "0");

                        if (firstDigitA !== firstDigitB) {
                          return firstDigitA - firstDigitB;
                        }

                        return a.tipoParametro - b.tipoParametro;
                      })
                      .map((item) => {
                        const tiposPresentes = new Set(
                          item.impostos.map((imp) => imp.tipoImposto)
                        );
                        const faltaIbsCbs = !tiposPresentes.has(4);

                        return (
                          <Card
                            key={item.id}
                            className="border border-secondary-subtle shadow-sm rounded-3 overflow-hidden bg-body"
                          >
                            {/* Card Top / Header */}
                            <Card.Header className="d-flex justify-content-between align-items-center bg-body-secondary border-bottom border-secondary-subtle py-2 px-3">
                              <div className="d-flex align-items-center flex-wrap gap-2">
                                <Badge
                                  bg="primary"
                                  className="fs-6 px-2.5 py-1 font-monospace"
                                >
                                  {item.cfop}
                                </Badge>
                                <div>
                                  <span
                                    className="fw-bold text-body-emphasis me-2"
                                    style={{ fontSize: "0.9rem" }}
                                  >
                                    {item.tipoParametroDescricao}
                                  </span>
                                  {item.tipoParametro !== 0 && (
                                    <Badge bg="secondary" className="fw-normal">
                                      Valor: {item.parametroValor}
                                    </Badge>
                                  )}
                                </div>
                              </div>
                              <Button
                                variant="outline-primary"
                                size="sm"
                                className="d-flex align-items-center gap-1 py-1 px-2.5 fw-semibold"
                                onClick={handleClickAlterar(
                                  item.id,
                                  item.tributacaoId
                                )}
                                title="Editar CFOP"
                              >
                                <FontAwesomeIcon icon={faPen} size="xs" />
                                <span className="ms-1">Editar</span>
                              </Button>
                            </Card.Header>

                            {/* Card Body / Grid de Impostos */}
                            <Card.Body className="p-3">
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <span
                                  className="text-secondary fw-bold text-uppercase"
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  Tributos Configurados ({item.impostos.length})
                                </span>
                                {item.impostos.length > 0 && (
                                  <small className="text-muted d-none d-sm-inline">
                                    Toque no tributo para alterar
                                  </small>
                                )}
                              </div>

                              {item.impostos.length > 0 ? (
                                <Row className="g-2">
                                  {item.impostos
                                    .sort((a, b) => a.tipoImposto - b.tipoImposto)
                                    .map((imposto) => {
                                      const isIbs = imposto.tipoImposto === 4;
                                      const cstStr = isIbs
                                        ? String(imposto.cst).padStart(3, "0")
                                        : String(imposto.cst).padStart(2, "0");

                                      return (
                                        <Col
                                          xs={12}
                                          sm={6}
                                          md={4}
                                          key={imposto.id}
                                        >
                                          <div
                                            role="button"
                                            tabIndex={0}
                                            className="p-2 border border-secondary-subtle rounded-2 d-flex align-items-center justify-content-between bg-body-tertiary text-body h-100 shadow-xs"
                                            style={{
                                              cursor: "pointer",
                                              transition:
                                                "border-color 0.15s ease, box-shadow 0.15s ease",
                                            }}
                                            onClick={handleClickImposto(
                                              imposto.id,
                                              imposto.tipoImposto,
                                              item.id
                                            )}
                                            onKeyDown={(e) => {
                                              if (
                                                e.key === "Enter" ||
                                                e.key === " "
                                              ) {
                                                handleClickImposto(
                                                  imposto.id,
                                                  imposto.tipoImposto,
                                                  item.id
                                                )(e as any);
                                              }
                                            }}
                                            title={`Editar ${imposto.tipoImpostoDescricao}`}
                                          >
                                            <div className="d-flex align-items-center gap-2">
                                              <Badge
                                                bg={getBadgeBg(
                                                  imposto.tipoImposto
                                                )}
                                                className="d-flex align-items-center justify-content-center fw-bold"
                                                style={{
                                                  width: "34px",
                                                  height: "30px",
                                                  fontSize: "0.75rem",
                                                }}
                                              >
                                                {getSigla(
                                                  imposto.tipoImposto,
                                                  imposto.tipoImpostoDescricao
                                                )}
                                              </Badge>
                                              <div>
                                                <div
                                                  className="fw-bold text-body-emphasis"
                                                  style={{
                                                    fontSize: "0.85rem",
                                                    lineHeight: "1.2",
                                                  }}
                                                >
                                                  {imposto.tipoImpostoDescricao}
                                                </div>
                                                <small
                                                  className="text-secondary font-monospace"
                                                  style={{ fontSize: "0.75rem" }}
                                                >
                                                  CST: {cstStr}
                                                </small>
                                              </div>
                                            </div>
                                            <FontAwesomeIcon
                                              icon={faChevronRight}
                                              className="text-muted ms-2"
                                              size="xs"
                                            />
                                          </div>
                                        </Col>
                                      );
                                    })}

                                  {/* Atalho caso falte IBS/CBS */}
                                  {faltaIbsCbs && (
                                    <Col xs={12} sm={6} md={4}>
                                      <div
                                        role="button"
                                        tabIndex={0}
                                        className="p-2 border border-dashed border-secondary-subtle rounded-2 d-flex align-items-center justify-content-between bg-body-secondary text-body-secondary h-100"
                                        style={{ cursor: "pointer" }}
                                        onClick={handleAddImposto(4, item.id)}
                                        title="Configurar Reforma Tributária IBS/CBS"
                                      >
                                        <div className="d-flex align-items-center gap-2">
                                          <Badge
                                            bg="secondary"
                                            className="d-flex align-items-center justify-content-center"
                                            style={{
                                              width: "34px",
                                              height: "30px",
                                              fontSize: "0.8rem",
                                            }}
                                          >
                                            +
                                          </Badge>
                                          <div>
                                            <div
                                              className="fw-semibold text-primary"
                                              style={{ fontSize: "0.8rem" }}
                                            >
                                              + IBS / CBS
                                            </div>
                                            <small
                                              className="text-secondary"
                                              style={{ fontSize: "0.7rem" }}
                                            >
                                              Reforma Tributária
                                            </small>
                                          </div>
                                        </div>
                                        <FontAwesomeIcon
                                          icon={faChevronRight}
                                          className="text-muted"
                                          size="xs"
                                        />
                                      </div>
                                    </Col>
                                  )}
                                </Row>
                              ) : (
                                <div className="alert alert-secondary border border-secondary-subtle py-2 px-3 mb-0 small d-flex flex-wrap align-items-center justify-content-between gap-2">
                                  <span className="text-body-secondary">
                                    Nenhum imposto configurado neste CFOP.
                                  </span>
                                  <Button
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={handleClickAlterar(
                                      item.id,
                                      item.tributacaoId
                                    )}
                                  >
                                    Adicionar Impostos
                                  </Button>
                                </div>
                              )}

                              {/* Atalhos Rápidos para adicionar outros impostos */}
                              <div className="mt-2 pt-2 border-top border-secondary-subtle d-flex flex-wrap align-items-center gap-2">
                                <span className="text-muted small me-1">
                                  + Adicionar:
                                </span>
                                {!tiposPresentes.has(0) && (
                                  <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    className="py-0 px-2"
                                    style={{ fontSize: "0.75rem" }}
                                    onClick={handleAddImposto(0, item.id)}
                                  >
                                    ICMS
                                  </Button>
                                )}
                                {!tiposPresentes.has(1) && (
                                  <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    className="py-0 px-2"
                                    style={{ fontSize: "0.75rem" }}
                                    onClick={handleAddImposto(1, item.id)}
                                  >
                                    IPI
                                  </Button>
                                )}
                                {!tiposPresentes.has(2) && (
                                  <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    className="py-0 px-2"
                                    style={{ fontSize: "0.75rem" }}
                                    onClick={handleAddImposto(2, item.id)}
                                  >
                                    PIS
                                  </Button>
                                )}
                                {!tiposPresentes.has(3) && (
                                  <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    className="py-0 px-2"
                                    style={{ fontSize: "0.75rem" }}
                                    onClick={handleAddImposto(3, item.id)}
                                  >
                                    COFINS
                                  </Button>
                                )}
                                {!tiposPresentes.has(4) && (
                                  <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    className="py-0 px-2"
                                    style={{ fontSize: "0.75rem" }}
                                    onClick={handleAddImposto(4, item.id)}
                                  >
                                    IBS/CBS
                                  </Button>
                                )}
                              </div>
                            </Card.Body>
                          </Card>
                        );
                      })}
                  </div>
                ) : (
                  <div className="text-center py-5 border border-secondary-subtle rounded-3 bg-body-tertiary my-3 shadow-xs">
                    <FontAwesomeIcon
                      icon={faReceipt}
                      size="2x"
                      className="text-secondary mb-2 opacity-50"
                    />
                    <h6 className="text-body-emphasis fw-bold mb-1">
                      Nenhuma CFOP vinculada a esta Tributação
                    </h6>
                    <p className="text-muted small mb-3">
                      Adicione as regras fiscais e códigos de operação (CFOP) aplicáveis.
                    </p>
                    <Button
                      variant="primary"
                      size="sm"
                      className="shadow-sm fw-semibold"
                      onClick={() =>
                        navigate(
                          `/fiscal/tributacao/cfop/cadastro?tributacaoid=${id}`
                        )
                      }
                    >
                      <FontAwesomeIcon icon={faPlus} className="me-1" />
                      Adicionar Primeira CFOP
                    </Button>
                  </div>
                )}
              </Tab>
            )}
          </Tabs>
        ) : (
          <Placeholder as={FloatingLabel} animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
        )}
      </Form>
    </Container>
  );
};

export default TributacaoCadastroView;
